import styled from 'styled-components';

export const Wrapper = styled.div`
  font-weight: 500;
`;

export const Suffix = styled.span`
  font-weight: normal;
  margin-right: 0.25rem;
`;
